import { render, staticRenderFns } from "./desempenho-carteira.vue?vue&type=template&id=df35f16c&scoped=true&"
import script from "./desempenho-carteira.vue?vue&type=script&lang=js&"
export * from "./desempenho-carteira.vue?vue&type=script&lang=js&"
import style0 from "./desempenho-carteira.vue?vue&type=style&index=0&id=df35f16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df35f16c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
